import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Alert, AlertTitle, Box } from "@mui/material";
import { useAuth } from "../AuthContext";
import { getOverdueDate } from "../TenantOverdue";

import DefaultLayout from "../components/DefaultLayout";
import DashboardOpenIncidentCountCard from "./DashboardOpenIncidentCountCard";
import DashboardLiveMapCard from "./DashboardLiveMapCard";
import DashboardVehicles from "../containers/DashboardVehicles";
import DashboardDataUsageCard from "./DashboardDataUsageCard";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  topMargin: {
    marginTop: theme.spacing(2),
  },
  permission: {
    fontSize: "1em",
    margin: 0,
  },
}));

const DashboardPage = ({ incidentsEnabled, vehiclesEnabled }) => {
  const classes = useStyles();
  const { isAuthenticated, account } = useAuth();
  const isOverdue = !!getOverdueDate(isAuthenticated, account);
  return (
    <DefaultLayout>
      <div>
        {isOverdue && (
          <Box marginBottom={2}>
            <Alert severity="error">
              <AlertTitle>Your account has an overdue payment</AlertTitle>
              Our records show a payment on your account is past its due date.
              To avoid any disruption to your service, please contact our
              accounts team on <a href="tel:+441270360360">
                01270 360 360
              </a> or{" "}
              <a href="mailto:accounts@fastview360.co.uk">
                accounts@fastview360.co.uk
              </a>
              . If you've paid recently, thank you. Please ignore this message
              while we update our records.
            </Alert>
          </Box>
        )}

        <Grid spacing={2} container>
          <Grid item xs={12} md={6} lg={4}>
            <DashboardOpenIncidentCountCard
              rowCount={2}
              incidentsEnabled={incidentsEnabled}
            />
            <div className={classes.topMargin}>
              <DashboardDataUsageCard />
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={8}>
            <DashboardLiveMapCard vehiclesEnabled={vehiclesEnabled} />
          </Grid>
          <Grid item xs={12} md={6} lg={8} />
        </Grid>

        <div className={classes.topMargin}>
          {vehiclesEnabled ? (
            <DashboardVehicles />
          ) : (
            <Card>
              <CardContent>
                <p className={classes.permission}>
                  You do not have permission to view vehicles
                </p>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </DefaultLayout>
  );
};

export default DashboardPage;
